import tick from "../assets/green-tick-teams.svg"
import summary from "../assets/summary-report-icon.svg"
import download from "../assets/summary-report-download.png"
import teams_api from "../api/protected/teams"
import reports_api from "../api/protected/reports"
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Select from "react-select";
import styles from "../utils/ReactSelectStyles";
import expand from "../assets/expand-teams.svg";
import collapse from "../assets/collapse.svg";


const EditTeamPreviousSurveysContainer = (props) => {

    const navigate = useNavigate()
    const [surveys, setSurveys] = useState([])
    const [surveyReports, setSurveyReports] = useState([])
    const [selectedReport, setSelectedReport] = useState(0)
    const [collapsed, setCollapsed] = useState(true)
    const [showNoSurveysPopup, setShowNoSurveysPopup] = useState(false)

    useEffect(() => {
        if(!props.team_id) return;
        getSurveys()
    }, [props.team_id]);

    const getSurveys = () => {
        let response = teams_api.getPreviousSurveys(props.team_id, props.isDemo)
        response.then(response => {
            setSurveys(response.data)
        }).catch(err => console.log(err))
    }

    const getSurveyPoint = (point) => {
        switch (point) {
            case 1: return "Initial";
            case 2: return "Midpoint";
            case 3: return "Endpoint";
            case 4: return "Post Review";
        }
    }

    const formatDate = (timestamp) => {
        let current_date = new Date(timestamp * 1000);
        return `${current_date.getDate()}/${current_date.getMonth() + 1}/${current_date.getFullYear()}`
    }

    const handleSummaryClick = (ev, id) => {
        navigate(`/surveys/${id}?overview=true${props.isDemo ? "&demo=true" : ""}`);
    }

    const handleDownloadClick = (ev, id) => {
        let response = reports_api.reportsBySurvey(id);
        response.then(response => {
            if (!response.data.length) {
                setShowNoSurveysPopup(true)
            }

            setSurveyReports(response.data)
            if(response.data.length === 1) {
                setSelectedReport(response.data[0])
            }
        }).catch(err => console.log(err))
    }

    const downloadReport = (report_id) => {
        let response = reports_api.downloadReport(report_id);
        response.then(response => {
            let a = document.createElement("a");
            a.href = response.data;
            a.download = "report.pdf";
            a.click();
        }).catch(err => console.log(err))
        setSurveyReports([])
        setSelectedReport(0)
    }

    const handleCollapse = (ev) => {
        if(!ev) return;
        setCollapsed(!collapsed)
    }


    return (
        <div className={`edit-team-previous-surveys-container ${collapsed ? "collapsed" : ""}`}>
            <div className="edit-team-details-top-row aligned">
                <div className="edit-team-details-title bold">Previous Surveys</div>
                <div className={`edit-team-previous-survey-collapse ${collapsed ? "collapsed" : ""}`} onClick={handleCollapse}>
                    <img src={collapsed ? expand : collapse} alt={collapsed ? "Show survey details" : "Hide survey details"}/>
                </div>
            </div>
            {!collapsed ?
                <>
                    <div className="edit-team-previous-surveys-headings medium">
                        <div className="previous-survey-heading">Survey Point</div>
                        <div className="previous-survey-heading small-col">Survey Type</div>
                        <div className="previous-survey-heading centred small-col">Participants</div>
                        <div className="previous-survey-heading small-col">Issue Date</div>
                        <div className="previous-survey-heading small-col">Expiry Date</div>
                        <div className="previous-survey-heading centred large-col">Overall Completion Rate</div>
                        <div className="previous-survey-heading centred">Survey Summary</div>
                        <div className="previous-survey-heading centred">Download Report</div>
                    </div>
                    {surveys.map((survey, idx) => {
                        return (
                            <div className="edit-team-previous-survey-row" key={idx}>
                                <div className="previous-survey-item short bold">{getSurveyPoint(survey.point)}</div>
                                <div
                                    className="previous-survey-item regular small-col">{survey.type === 1 ? "Full" : "Lite"}</div>
                                <div className="previous-survey-item centred regular small-col">{survey.participant_count}</div>
                                <div className="previous-survey-item regular small-col">{formatDate(survey.created_date)}</div>
                                <div className="previous-survey-item regular small-col">{formatDate(survey.expiry_date)}</div>
                                <div className="previous-survey-item icon-container large-col">
                                    <div className="previous-survey-subitem bold">{Number.isInteger(survey.completion_avg)
                                        ? survey.completion_avg
                                        : survey.completion_avg.toFixed(2)
                                    }%</div>
                                    <div className="previous-survey-subitem-img">
                                        {survey.completion_avg === 100 ? <img src={tick} alt=""/> : null}
                                    </div>
                                </div>
                                <div className="previous-survey-item centred" onClick={ev => handleSummaryClick(ev, survey.id)}>
                                    <img src={summary} alt="Run summary" className="clickable"/>
                                </div>
                                <div className="previous-survey-item short centred" onClick={ev => handleDownloadClick(ev, survey.id)}>
                                    <img src={download} alt="Download report" className="clickable"/>
                                </div>
                            </div>
                        )
                    })}
                    {surveyReports.length ?
                        <>
                            <div className="page-mask" onClick={() => {
                                setSurveyReports([])
                                setSelectedReport(0)
                            }}/>
                            <div className="report-download-popup-container">
                                <div className="report-download-popup-title bold">Select Report</div>
                                <div className="report-download-popup-select">
                                    <Select options={surveyReports}
                                            getOptionLabel={x => x.name} getOptionValue={x => x.id}
                                            value={selectedReport} placeholder="" onChange={ev => setSelectedReport(ev)}
                                            styles={styles.registerStyles}
                                    />
                                </div>
                                <div className="report-download-popup-buttons bold">
                                    <div className="report-download-button" onClick={() => {
                                        setSurveyReports([])
                                        setSelectedReport(0)
                                    }}>CANCEL</div>
                                    <div className="report-download-button filled"
                                         onClick={() => downloadReport(selectedReport.id)}>
                                        DOWNLOAD
                                    </div>
                                </div>
                            </div>
                        </> : null
                    }
                    {showNoSurveysPopup ?
                        <>
                            <div className="page-mask" onClick={() => setShowNoSurveysPopup(false)}/>
                            <div className="report-no-surveys-popup-container">
                                <div className="report-no-surveys-popup-text medium">
                                    There are no reports available to download for this survey
                                </div>
                                <div className="report-no-surveys-popup-buttons bold">
                                    <div className="report-download-button filled"
                                         onClick={() => setShowNoSurveysPopup(false)}>
                                        OK
                                    </div>
                                </div>
                            </div>
                        </> : null

                    }
                </> : null
            }
        </div>
    )
}


export default EditTeamPreviousSurveysContainer